import {
  DEFAULT_NOTIFICATION_TIMEOUT_MS,
  DELETE_SEGEMENT_MESSAGE,
  DELETE_SEGMENT_FAILED,
  FileUploadStatus,
  MessageType,
} from '../constants/createSegment';
import { API_ERROR } from '../constants/editorConfig';
import {
  FAILED_SEGMENT_DOWNLOAD,
  SEGMENT_DOWNLOAD_SUCCESS,
  SEGMENT_UPDATE_FAILED,
  SEGMENT_UPDATE_SUCCESSFUL,
} from '../constants/messages';
import {
  DELETE_SEGMENT_URL,
  DOWNLOAD_SEGMENT_URL,
  UPDATE_SEGMENT_URL,
} from '../constants/urlConstants';
import { ResponseStatus } from '../enums/responseStatus';
import apiRequest from '../util/apiRequest';
import getFileContent from '../util/segmentCreation/getFileContent';
import {
  REMOVE_UPLOADED_FILE,
  PROCESS_UPLOADED_FILE,
  DOWNLOAD_SEGMENT,
  SET_SEGMENT_OPERATION,
  SET_SEGMENT_DATA,
  UPDATE_SEGMENT_API_STATUS,
} from './createSegmentActionTypes';
import { displayNotification } from './notificationActions';
import { SHOW_NOTIFICATON } from './notificationActionsType';
import { CREATE_SEGMENT_FROM_FILE } from './nudgeActionTypes';

export const getFileDetails = file => dispatch => {
  let fileInfo = {};
  return getFileContent(file)
    .then(data => {
      fileInfo = {
        content: data,
        fileName: file.name,
        fileSize: file.size,
        isUploaded: true,
        status: FileUploadStatus.SUCCESS,
      };
    })
    .catch(e => {
      fileInfo = {
        content: '',
        fileName: '',
        fileSize: '',
        isUploaded: false,
        status: FileUploadStatus.ERROR,
      };
    })
    .finally(() => {
      dispatch({
        type: PROCESS_UPLOADED_FILE,
        payload: fileInfo,
      });
    });
};

export const removeFileDetails = () => dispatch => {
  const fileInfo = {
    content: '',
    fileName: '',
    fileSize: '',
    isUploaded: false,
    status: null,
  };
  dispatch({
    type: REMOVE_UPLOADED_FILE,
    payload: fileInfo,
  });
};

export const deleteSegment = (payload = {}, sessionToken) => dispatch => {
  let status = ResponseStatus.RUNNING;
  let data = {};
  return apiRequest(
    DELETE_SEGMENT_URL,
    {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify({
        ...payload,
      }),
    },
    sessionToken,
  )
    .then(res => {
      if (!res.ok) {
        status = ResponseStatus.ERROR;
        throw Error(API_ERROR);
      }
      return res.json();
    })
    .then(res => {
      status = ResponseStatus.SUCCESS;
      data = res;
      dispatch(
        displayNotification({
          type: MessageType.SUCCESS,
          message: DELETE_SEGEMENT_MESSAGE,
          timeout: DEFAULT_NOTIFICATION_TIMEOUT_MS,
        }),
      );
    })
    .catch(ex => {
      status = ResponseStatus.ERROR;
      dispatch(
        displayNotification({
          type: MessageType.ERROR,
          message: DELETE_SEGMENT_FAILED,
          timeout: DEFAULT_NOTIFICATION_TIMEOUT_MS,
        }),
      );
    });
};

export const downloadSegment = (payload = {}, sessionToken) => dispatch => {
  let status = ResponseStatus.RUNNING;
  let data = {};
  return apiRequest(
    DOWNLOAD_SEGMENT_URL,
    {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify({
        ...payload,
      }),
    },
    sessionToken,
  )
    .then(res => {
      if (!res.ok) {
        status = ResponseStatus.ERROR;
        throw Error(API_ERROR);
      }
      return res.json();
    })
    .then(res => {
      status = ResponseStatus.SUCCESS;
      data = res;
      const iframe = document.createElement('iframe');
      iframe.src = res.downloadUrl;
      iframe.style = 'display: none;';
      document.body.append(iframe);
      dispatch({
        type: SHOW_NOTIFICATON,
        payload: {
          type: MessageType.SUCCESS,
          message: SEGMENT_DOWNLOAD_SUCCESS,
          timeout: DEFAULT_NOTIFICATION_TIMEOUT_MS,
        },
      });
    })
    .catch(ex => {
      status = ResponseStatus.ERROR;
      dispatch({
        type: SHOW_NOTIFICATON,
        payload: {
          type: MessageType.ERROR,
          message: FAILED_SEGMENT_DOWNLOAD,
          timeout: DEFAULT_NOTIFICATION_TIMEOUT_MS,
        },
      });
    })
    .finally(() => {
      dispatch({
        type: DOWNLOAD_SEGMENT,
        payload: {
          status,
          response: data,
        },
      });
    });
};

export const updateSegment = (payload = {}, sessionToken) => dispatch => {
  return apiRequest(
    UPDATE_SEGMENT_URL,
    {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify({
        ...payload,
      }),
    },
    sessionToken,
  )
    .then(res => {
      if (!res.ok) {
        throw Error(API_ERROR);
      }
      return res.json();
    })
    .then(() => {
      dispatch({
        type: SHOW_NOTIFICATON,
        payload: {
          type: MessageType.INFO,
          message: SEGMENT_UPDATE_SUCCESSFUL,
          timeout: 20000,
        },
      });
      dispatch(updateSegmentApiStatus(ResponseStatus.SUCCESS));
    })
    .catch(() => {
      dispatch({
        type: SHOW_NOTIFICATON,
        payload: {
          type: MessageType.ERROR,
          message: SEGMENT_UPDATE_FAILED,
          timeout: DEFAULT_NOTIFICATION_TIMEOUT_MS,
        },
      });
      dispatch(updateSegmentApiStatus(ResponseStatus.ERROR));
    });
};

export const setEditOperation = payload => dispatch => {
  dispatch({
    type: SET_SEGMENT_OPERATION,
    payload,
  });
};

export const setSegmentData = payload => dispatch => {
  dispatch({
    type: SET_SEGMENT_DATA,
    payload,
  });
};

export const updateSegmentApiStatus = payload => dispatch => {
  dispatch({
    type: UPDATE_SEGMENT_API_STATUS,
    payload,
  });
};
